/**
 * Tailwind CSS implementation of Numeral component
 * Uses Seeds numeral CSS classes from numeral.css
 *
 * NOTE: mirror Button — do NOT `import "./numeral.css"`. The CSS ships via a
 * build-step copy (cp src/numeral.css dist/numeral.css) and the global racine
 * aggregation, not via a source-level import.
 */

import * as React from "react";
import Text from "@sproutsocial/seeds-react-text";
import { renderNumeral } from "./getNumeral";
import type { TypeNumeralProps } from "./NumeralTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

// Plain Text wrappers carrying the numeral.css classes. Text forwards
// className and the remaining props (incl. non-styled typography props like
// fontSize/fontWeight) to its DOM span, so the classes land on the span.
const TwContainer = ({ className, children, ...rest }: any) => (
  <Text className={cn("seeds-numeral", className)} {...rest}>
    {children}
  </Text>
);

const TwAbbrContainer = ({ className, children, ...rest }: any) => (
  <Text
    className={cn("seeds-numeral", "seeds-numeral-abbr", className)}
    {...rest}
  >
    {children}
  </Text>
);

export const NumeralTailwind = (props: TypeNumeralProps): React.ReactNode =>
  renderNumeral(props, {
    Container: TwContainer,
    AbbrContainer: TwAbbrContainer,
  });
